<template>
  <header class="topbar">
    <nav class="navbar top-navbar navbar-expand-md navbar-light">
      <div class="navbar-header">
        <a class="nav-toggler waves-effect waves-light d-block d-md-none" href="javascript:void(0)"><i class="ti-menu ti-close" /></a>
        <router-link :to="{name: 'dashboard'}" class="navbar-brand">
          <!-- Logo icon -->
          <b class="logo-icon">
            <img alt="homepage" class="dark-logo" height="30" src="../../assets/images/logo/logo-icon.png">
            <img alt="homepage" class="light-logo" height="30" src="../../assets/images/logo/logo-icon.png">
          </b>
          <!--End Logo icon -->
          <!-- Logo text -->
          <span class="logo-text">
            <img alt="homepage" class="dark-logo" height="30" src="../../assets/images/logo/logo-text-lg.png">
            <img alt="homepage" class="light-logo" height="30" src="../../assets/images/logo/logo-text-lg.png">
          </span>
        </router-link>
        <a aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" class="topbartoggler d-block d-md-none waves-effect waves-light" data-target="#navbarSupportedContent" data-toggle="collapse" href="javascript:void(0)"><i class="ti-more" /></a>
      </div>
      <div id="navbarSupportedContent" class="navbar-collapse collapse">
        <ul class="navbar-nav float-left mr-auto">
          <li class="nav-item d-none d-md-block">
            <a class="nav-link sidebartoggler waves-effect waves-light" data-sidebartype="mini-sidebar" href="javascript:void(0)">
              <i class="mdi mdi-menu font-24" />
            </a>
          </li>
        </ul>
        <ul class="navbar-nav float-right">
          <li class=" dropdown custom-border-right custom-border-left p-t-5">
            <a aria-expanded="false" aria-haspopup="true" class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button">
              <div class="d-flex no-block align-items-center ">
                <h6 class="p-t-5"><b>Wallet:</b>&nbsp;&nbsp;</h6>
                <address-book-by-public-key :public-key="publicKey" />
              </div>
            </a>
            <div aria-labelledby="navbarDropdown" class="dropdown-menu dropdown-menu-right mailbox animated bounceIn">
              <router-link :to="{ name: 'wallets'}" class="dropdown-item">
                <i class="fas fa-key m-r-5 m-l-5" /> Wallets
              </router-link>
            </div>
          </li>
          <li class=" dropdown custom-border-right p-t-5">
            <div id="navbarDropdown" aria-expanded="false" aria-haspopup="true" class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button">
              <span class="with-arrow" />
              <div class="d-flex no-block align-items-center ">
                <h6 class="p-t-5">
                  <b>Group:</b>&nbsp;&nbsp;
                </h6>
                <address-book-by-public-key v-if="activeGroup" :public-key="activeGroup.anonymous_account" />
                <a v-else class="form-text text-muted p-b-5" href="javascript:void(0)">NA</a>
              </div>
            </div>
            <div aria-labelledby="navbarDropdown" class="dropdown-menu dropdown-menu-right mailbox animated bounceIn">
              <router-link :to="{ name: 'groups'}" class="dropdown-item">
                <i class="fas fa-object-group m-r-5 m-l-5" /> Groups
              </router-link>
            </div>
          </li>
          <li class="nav-item dropdown custom-border-right">
            <a aria-expanded="false" aria-haspopup="true" class="nav-link dropdown-toggle waves-effect waves-dark notifications" data-toggle="dropdown" href="" @click="getNotifications">
              <i class="mdi mdi-bell font-24" />
              <span v-if="notifications.length >0" class="num">{{ notifications.length }}</span>
            </a>
            <div class="dropdown-menu dropdown-menu-right mailbox animated bounceInDown">
              <span class="with-arrow"><span class="bg-info" /></span>
              <ul class="list-style-none">
                <li>
                  <div class="drop-title bg-info text-white">
                    <h4 class="m-b-0 m-t-5">
                      {{ notifications.length }} New
                    </h4>
                    <span class="font-light">Notifications</span>
                  </div>
                </li>
                <li>
                  <div class="message-center notifications">
                    <a v-for="notification in notifications" :key="notification.proposal_id" :class="{'unseen-notification': notification.visibility === 'UNSEEN'}" class="message-item custom-border-bottom" href="javascript:void(0)" @click="toProposal(notification.proposal_id)">
                      <span v-if="notification.module === 'Audits'" class="btn btn-circle btn-success">
                        <i class="fas fa-clipboard-list" />
                      </span>
                      <span v-if="notification.module === 'purchase'" class="btn btn-circle btn-flickr">
                        <i class="fas fa-cart-arrow-down" />
                      </span>
                      <span v-if="notification.module === 'sale'" class="btn btn-circle btn-primary">
                        <i class="fas fa-credit-card" />
                      </span>
                      <span v-if="notification.module === 'invoice'" class="btn btn-circle btn-tumblr">
                        <i class="fas fa-money-bill-alt" />
                      </span>
                      <span class="mail-contnet">
                        <h5 class="message-title">{{ notification.module }}:&nbsp;{{ notification.description }}</h5>
                        <span class="mail-desc text-black-50">You have this proposal to vote</span>
                        <span class="time text-black-50">{{ notification.created_at| timestamp }}</span>
                      </span>
                    </a>
                  </div>
                </li>
                <li>
                  <a class="text-info nav-link custom-border-top" href="javascript:void(0);">
                    <router-link :to="{name: 'proposals'}" class="float-left"><u>View all Events</u>
                    </router-link>
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a aria-expanded="false" aria-haspopup="true" class="nav-link dropdown-toggle text-muted waves-effect waves-dark pro-pic" data-toggle="dropdown" href="">
              <img alt="" class="rounded-circle" :src="profileImage" style="width:40px; height:auto;">
              <b style="color: black">{{ currentUser && currentUser.name }}</b>
            </a>
            <div class="dropdown-menu dropdown-menu-right user-dd animated flipInY">
              <span class="with-arrow"><span class="bg-primary" /></span>
              <div class="d-flex no-block align-items-center p-15 bg-secondary text-white m-b-10">
                <div class="">
                  <img alt="" class="rounded-circle" :src="profileImage" style="width:50px; height:auto;">
                  <!--                                    <blockie :address="currentUser.email" v-if="currentUser"></blockie>-->
                </div>
                <div class="m-l-10">
                  <h4 class="m-b-0">
                    {{ currentUser && currentUser.name }}
                  </h4>
                  <h5 v-if="activeGroup" class="m-b-0">
                    Group: {{ activeGroup.name }}
                  </h5>
                  <h5 v-else class="m-b-0">
                    Group: NA
                  </h5>
                </div>
              </div>
              <router-link v-if="currentUser" :to="{ name: 'userprofile', params: {userId: currentUser.id}}" class="dropdown-item">
                <i class="fas fa-user m-r-5 m-l-5" /> My Profile
              </router-link>
              <router-link :to="{ name: 'groups'}" class="dropdown-item">
                <i class="fas fa-object-group m-r-5 m-l-5" /> Groups
              </router-link>
              <router-link :to="{ name: 'address-book-entries'}" class="dropdown-item">
                <i class="fas fa-address-book m-r-5 m-l-5" /> Address Book
              </router-link>
              <router-link :to="{ name: 'changepassword'}" class="dropdown-item" exact>
                <i class="fa fa-key m-r-5 m-l-5" /><span class="hide-menu"> Change Password</span>
              </router-link>
              <div class="dropdown-divider" />
              <a class="dropdown-item" href="javascript:void(0)" @click="handleLogout()">
                <i class="fa fa-power-off m-r-5 m-l-5" /> Logout
              </a>
              <div class="dropdown-divider" />
              <div class="p-l-30 p-10">
                <router-link :to="{name: 'viewprofile'}" class="btn btn-sm btn-success btn-rounded">
                  View Profile
                </router-link>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import AddressBookByPublicKey from './common/AddressBookByPublicKey.vue';
import defaultImage from '@/assets/images/DP.svg';
import { proposalStatus } from '@/utils/utils';

export default {
  name: 'WorkspaceTopbar',
  components: { AddressBookByPublicKey },
  data() {
    return {
      notifications: [],
      newNotificationCount: 0,
      profileImage: defaultImage

    };
  },
  computed: {
    ...mapGetters(['currentUser', 'activeGroup', 'publicKey'])
  },
  mounted() {
    this.$root.$on('updateNotifications', () => {
      this.init();
    });
    this.init();
  },
  methods: {
    async init() {
      await this.getNotifications();
      await this.getProfileImage();
    },
    async getProfileImage() {
      try {
        const { data } = await this.$accounts.get('/users/get_profile_image');
        this.profileImage = 'data:image/png;base64,' + data;
      } catch (e) {
        // user does not have a profile image
      }
    },
    async getNotifications() {
      try {
        const { data } = await this.$api.get('/groups/proposals');
        this.notifications = [];
        data.forEach(group => {
          const proposals = group[1];
          proposals.forEach(proposal => {
            proposal.group_id = group[0];
            proposalStatus(proposal, this.publicKey);
            if (proposal.status == 'InProgress') {
              const yes_voters = proposal.votes.ayes.map(y => y[0]);
              const no_voters = proposal.votes.nays.map(n => n[0]);
              if (!yes_voters.includes(this.publicKey) && !no_voters.includes(this.publicKey)) {
                this.notifications.push(proposal);
              }
            }
          });
        });
      } catch (e) {
        console.error(e);
      }
    },
    handleLogout() {
      this.$store.commit('LOGOUT');
      this.$router.replace('/auth/login');
    },

    toProposal(proposalId) {
      this.$router.push({ name: 'view-proposal', params: { proposalId: proposalId } });
    }
  }
}
</script>

<style scoped>
.unseen-notification {
  background-color: #edf2fa;
}

.unseen-notification:hover {
  background: #e9ebee !important;
}

.custom-border-bottom {
  border-bottom-width: 2px !important;
  border-bottom-style: inset !important;
  border-bottom-color: rgb(226, 226, 213) !important;
}

.custom-border-top {
  border-top-width: 1px !important;
  border-top-style: solid !important;
  border-top-color: #cad2e8 !important;
}

.notifications .num {
  position: absolute;
  top: 7px;
  left: 30px;
  height: 20px;
  border-radius: 2px;
  background: #ff2c74;
  color: #fff;
  line-height: 20px;
  font-family: sans-serif;
  text-align: center;
  padding: 0px 4px;
}

.custom-express {
  font-size: 11px;
  position: absolute;
  top: 16px;
  left: 108px;
}

.custom-border-right {
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: rgba(0, 0, 0, 0.1);
}

.custom-border-left {
  border-left-width: 1px;
  border-left-style: solid;
  border-left-color: rgba(0, 0, 0, 0.1);
}
</style>
